import {Button} from 'antd';
import styled from 'styled-components';
import {bordersStyles} from '../../../../utils/styles';

const StyledPayNowForm = styled.div`
  ${bordersStyles.default};
  
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 20px;
`;

const StyledPayNowFormButton = styled(Button)`
  width: 100%;
`;

export {
  StyledPayNowForm,
  StyledPayNowFormButton
}